import { IMG_NO_RESULTS_PRODUCT_COMPARISON } from "../utils/url/staticResources";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import classes from "./EmptyComparison.module.less";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { Button } from "~/common/components/Button/Button";
import { useTranslation } from "react-i18next";

const EmptyComparison = ({ openQuickEntry }: { openQuickEntry: () => void }) => {
  const { t } = useTranslation();
  const { maxSize } = window.SCHA.productComparisonList;

  return (
    <>
      <PageTitle title={t("comparisonPage.title", { length: 0, maxSize })} />

      <div className={classes.container}>
        <h1 className={classes.title}>{t("emptyComparison.title")}</h1>

        <img className={classes.img} src={IMG_NO_RESULTS_PRODUCT_COMPARISON} alt={""} />

        <div className={classes.btnAdd}>
          <Button onClick={openQuickEntry}>{t("emptyComparison.addProducts")}</Button>
        </div>

        <Button variant={"text"} onClick={() => redirectToUrl(HOMEPAGE)}>
          {t("emptyComparison.backHome")}
        </Button>
      </div>
    </>
  );
};

export default EmptyComparison;
